module.exports = __webpack_public_path__ + "img/ad1b5c102d718a66dac09b56d3e0534d.png";